<template>
  <Flex direction="column">
    <BaseCard>
      <Flex direction="column">
        <BaseHeading>
          {{ $t('export_page.fiskaly_archive.step_1.heading') }}
        </BaseHeading>
        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_1.step_1') }}

          <BaseText
            href="https://sign-fr-tax-archive-tools-1091330669471.europe-west3.run.app/v2/archive-downloader.html"
            target="_blank"
          >
            {{ $t('export_page.fiskaly_archive.step_1.archive_link') }}
          </BaseText>
        </BaseText>
        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_1.step_2') }}
          <BaseText
            v-test="'fiskaly-archive-api-link'"
            :routerLink="{ name: 'integration-fiskaly-sign-info' }"
          >
            {{ $t('export_page.fiskaly_archive.step_1.api_link') }}
          </BaseText>
        </BaseText>
        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_1.step_3') }}
        </BaseText>
      </Flex>
    </BaseCard>

    <BaseCard>
      <Flex direction="column">
        <BaseHeading>
          {{ $t('export_page.fiskaly_archive.step_2.heading') }}
        </BaseHeading>
        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_2.step_1') }}
        </BaseText>

        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_2.step_2') }}
        </BaseText>

        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_2.step_3') }}
        </BaseText>
      </Flex>
    </BaseCard>

    <BaseCard>
      <Flex direction="column">
        <BaseHeading>
          {{ $t('export_page.fiskaly_archive.step_3.heading') }}
        </BaseHeading>
        <BaseText
          href="https://sign-fr-tax-archive-tools-1091330669471.europe-west3.run.app/v2/tax-archive-viewer.html"
          target="_blank"
        >
          {{ $t('export_page.fiskaly_archive.step_3.link') }}
        </BaseText>
        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_3.step_1') }}
        </BaseText>
        <BaseText>
          {{ $t('export_page.fiskaly_archive.step_3.help_center_text') }}
          <BaseText
            :href="helpCenterArticleUrl(16109879)"
            inline
          >
            {{ $t('export_page.fiskaly_archive.step_3.help_center_link_text') }}
          </BaseText>
        </BaseText>
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { helpCenterArticleUrl } from '@/helpers/help-center';
</script>
